module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("‘Letters are like wine; if they are sound they ripen with keeping’")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("S"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AMUEL")]), _vm._v(" B"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("UTLER")])]), _vm._v(" "), _c('p', {
    staticClass: "txs"
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("‘Sometimes, one’s heart quails at the thought of the things that lie ahead, and then one counts one’s blessings – and things don’t seem so bad!’")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HE")]), _vm._v(" Q"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("UEEN")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("5 May 1939 to the Archbishop of Canterbury")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0